import { UniqueIdentifier } from "@dnd-kit/core";

export const sortOnDragEnd = (
  idsIn: UniqueIdentifier[],
  activeId?: UniqueIdentifier,
  overId?: UniqueIdentifier,
): UniqueIdentifier[] => {
  const oldIndex = idsIn.findIndex((id) => id === activeId);
  const newIndex = idsIn.findIndex((id) => id === overId);
  const [movedItem] = idsIn.splice(oldIndex, 1);
  idsIn.splice(newIndex, 0, movedItem);
  return idsIn;
};
